import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import Popover from 'modules/core/components/Popover'
import ScrollableList from 'modules/core/components/ScrollableList'
import i18n from 'modules/core/lib/i18n'

import ItemsCategory from './ItemsCategory'
import type { Category } from './variables'

interface BodyVariablesProps {
  items: JSX.Element[]
  categories: Category[]
  showVariables: boolean
  toggleShowVariables: (value: boolean) => () => void
}

const BodyVariables = ({
  items,
  categories,
  showVariables,
  toggleShowVariables,
}: BodyVariablesProps) => {
  if (!items.length || !categories.length) return null

  return (
    <Box paddingBottom="s6" alignItems="flexEnd">
      <Popover attachment="top center" open={showVariables} toggle={toggleShowVariables}>
        <Box cursor="pointer" flexDirection="row" alignItems="center">
          <Icon.Small icon="add" color="viridian1000" />
          <Text size="200" color="viridian1000" weight="medium">
            {i18n.t('automations.actions.send_custom_notification.variables.action')}
          </Text>
        </Box>
        <ScrollableList>
          <Box>
            {categories.map((category) => {
              const catItems = items.filter((item) => item.props.item.category === category.key)

              if (catItems.length === 0) return null

              const label = category.label().toLowerCase()

              return (
                <ItemsCategory key={category.key} label={label}>
                  {catItems}
                </ItemsCategory>
              )
            })}
          </Box>
        </ScrollableList>
      </Popover>
    </Box>
  )
}

export default BodyVariables
